import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageBackendValidatorsEnum } from '@zaoblako/shared/modules/storage/enums/storage-backend-validators.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** Profile create/update request body */
export interface ProfileFormInterface {
  /** User email address (login) */
  email: string;
  /** User's phone number */
  phone?: string;
  /** User's first (personal) name */
  firstName: string;
  /** User's middle (additional) name or surname */
  middleName?: string;
  /** User's last (family) name */
  lastName: string;
  /** User's avatar file */
  file?: OnlyIdRequiredInterface<FileFindInterface>;
}

/** Profile create/update request body - DTO schema */
export const ProfileFormDto = SerdeDtoClass.create<ProfileFormInterface>(SecurityDtoKeysEnum.PROFILE_FORM_DTO, {
  email: {
    sortable: true,
    label: 'Email',
    checkers: [SecurityBackendValidatorsEnum.PROFILE_EMAIL_UNIQUE],
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
  phone: {
    sortable: true,
    optional: true,
    label: 'Телефон',
    serializer: yup
      .string()
      .matches(/^7\d{10}$/i, DtoMessageEnum.INCORRECT_PHONE),
  },
  firstName: {
    label: 'Имя',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  middleName: {
    optional: true,
    label: 'Отчество',
    serializer: yup.string(),
  },
  lastName: {
    label: 'Фамилия',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  file: {
    optional: true,
    label: 'Аватар',
    serializer: entityLikeSchema,
    checkers: [StorageBackendValidatorsEnum.FILE_ASSERT_EXISTS_BY_DTO],
  },
});
